<template>
  <div v-show="visible" :id="$attrs['id']" class="kbd-shortcuts__backdrop" @click="visible = false">
    <div class="kbd-shortcuts__background">
      <hm-col :grid="true" cols="12">
        <hm-col :grid="true" class="kbd-shortcuts__container" cols="12 6@tablet 4@desktop">
          <hm-col cols="12">
            <h1>{{ $t('util.keyboardShortcutOverlay.commonShortcuts') }}</h1>
          </hm-col>
          <template v-for="(label, keys, shortcutIdx) in commonShortcuts">
            <hm-col :key="`common-key-${shortcutIdx}`" class="kbd-shortcuts__shortcut" cols="5 4@tablet">
              <template v-for="(key, idx) in splitKeys(keys)">
                <kbd v-html="key"></kbd>
                <template v-if="idx < (splitKeys(keys).length - 1)">
                  +
                </template>
              </template>
            </hm-col>
            <hm-col :key="`common-label-${shortcutIdx}`" cols="7 8@tablet" v-html="label"></hm-col>
          </template>
        </hm-col>
        <hm-col v-if="!isEmpty(pageShortcuts)" :grid="true" class="kbd-shortcuts__container" cols="12 6@tablet 4@desktop">
          <hm-col cols="12">
            <h1>{{ $t('util.keyboardShortcutOverlay.pageSpecificShortcuts') }}</h1>
          </hm-col>
          <template v-for="(label, keys, shortcutIdx) in pageShortcuts">
            <hm-col :key="`page-key-${shortcutIdx}`" class="kbd-shortcuts__shortcut" cols="5 4@tablet">
              <template v-for="(key, idx) in splitKeys(keys)">
                <kbd v-html="key"></kbd>
                <template v-if="idx < (splitKeys(keys).length - 1)">
                  +
                </template>
              </template>
            </hm-col>
            <hm-col :key="`page-label-${shortcutIdx}`" cols="7 8@tablet" v-html="label"></hm-col>
          </template>
        </hm-col>
      </hm-col>
    </div>
  </div>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { clone, isEmpty, isNil, startsWith } from 'lodash';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';

export default {
  name: 'KeyboardShortcutsOverlay',

  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],

  props: {
  },

  data() {
    return {
      visible: false,
      commonShortcuts: [],
      pageShortcuts: [],
    };
  },

  computed: {
  },

  created: function () {
    this.$serviceBus.$on('keyboardShortcuts.show', this.showModal);
    this.$serviceBus.$on('keyboardShortcuts.hide', this.hideModal);
    this.$serviceBus.$on('shortcut.esc', this.hideModal);
  },

  methods: {
    splitKeys(keys) {
      if (isEmpty(keys)) return keys;
      return keys.split('+');
    },
    showModal(commonShortcuts, pageShortcuts) {
      this.commonShortcuts = commonShortcuts;
      this.pageShortcuts = pageShortcuts;
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .kbd-shortcuts {
    &__backdrop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000000;
      transition: opacity 0.15s ease;
      opacity: 1;
      backdrop-filter: saturate(90%) blur(2px);

      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: all;

      line-height: 27px;
      color: #fff;
      text-align: left!important;
    }

    &__background {
      position: fixed;
      padding: 0.5rem;
      border-radius: 0.3rem;
      background-color: rgba(0, 0, 0, 0.55);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;

      @media (min-width: $br-tablet) {
        top: calc(3vh + 60px);
        left: 3vh;
        right: 3vh;
        bottom: 3vh;
        padding: 1.5rem;
      }

      @media (min-width: $br-desktop) {
        top: calc(3vh + 60px);
        left: calc(50px + 3vh);
        right: 3vh;
        bottom: 3vh;
        padding: 1.5rem;
      }
    }

    &__shortcut {
      white-space: nowrap;
    }

    &__container {
      > * {
        padding: 0.3rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/KeyboardShortcutsOverlay.vue